// initial state
import * as base from './base.js'
const baseName = '/admin/api/cases'
const baseCategoryName = '/admin/api/cases_category'
const categorynotPagelist = '/admin/api/content/notPagelistcategory'
const baseCategorys = '/admin/api/cases_category/lists'

const obj = base.setBaseUrl('cases', baseName)
const obj1 = base.setBaseUrl('cases_category', baseCategoryName)

const a = Object.assign(obj,obj1, {categorynotPagelist,baseCategorys})
export default a
